import { ThemeIcon, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { types } from "../components/jobs/jobTypes";

export const minimizedSize = 475;
export const maximizedSize = 840;
export const hiddenSize = 16;

export function getRowClasses({ params, mainId, integerId, isHoverSource }) {
  let final = " bump-stroke";
  if (mainId !== "none") {
    if (params.id === integerId) {
      final = final.concat(" selected");
    } else {
      final = final.concat(" not-selected");
    }
  }

  if (mainId === "all") {
    final = final.concat(" selected");
  }

  if (isHoverSource && !params?.pin) {
    final = final.concat(" hover-source");
  }

  return final;
}

export const getListOrigin = (row) => {
  const lang = useLanguage.getState().language;
  let originDetails = row?.state_details[row.state_details.length - 1];
  if (!originDetails)
    return (
      <Tooltip
        label={`${lang.contact_lists.origin}: ${types("Creation", true).label}`}
      >
        <ThemeIcon variant="subtle">{types("Creation", true).icon}</ThemeIcon>
      </Tooltip>
    );
  return (
    <Tooltip
      label={`${lang.contact_lists.origin}: ${
        types(originDetails?.type, true).label
      }`}
    >
      <ThemeIcon variant="subtle">{types(originDetails?.type).icon}</ThemeIcon>
    </Tooltip>
  );
};
